module.exports = __webpack_public_path__ + "img/NT-After.f33784d5.png";